// @flow

import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import Button from "../../_atom/Buttons/button";
import { generateTransition, linear } from "../../_static/Transitions";
import buildColor from "../../_static/ColorPalette";
import { fontMedium } from "../../_static/Typography";
import { buildText } from "../../_atom/Text/index";

const RaceHeaderContainer = styled.div`
  flex: 0 0 auto;
  background-color: ${buildColor("blue", "700")};
  padding: 0 8px 8px;
  ${(props) =>
    props.isSticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 2;
      padding: 8px 8px 0;
      border-radius: 2px 2px 0 0;
    `};
`;

export const VideoButtonWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 50%;
  padding-left: 4px;
`;

export const PoolsInfoButtonWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 50%;
  padding-right: 4px;
`;

export const PoolsInfoButton = styled(Button)`
  background-color: ${buildColor("white", "20")};
  font-family: ${fontMedium};
  font-size: 14px;
`;

export const WrapSpan = styled(
  buildText({
    fontSize: 14,
    tag: "span",
    uppercase: false
  })
)`
  text-transform: capitalize;
  padding-left: 4px;
  font-family: ${fontMedium};
`;

export const ControlButtonsContainer = styled.div`
  opacity: ${(props) => (props.dismissControllButtons ? "0" : "1")};
  will-change: opacity;
  transition: ${generateTransition(linear, "opacity")};
`;

export const RaceInfoContainer = styled.div`
  margin: 8px 0;
`;

export const RaceNavigationContainer = styled.div`
  opacity: ${(props) => (props.dismissRaceNavigation ? "0" : "1")};
  will-change: opacity;
  transition: ${generateTransition(linear, "opacity")};
  display: flex;
  justify-content: space-between;
  ${(props) =>
    props.onVideo &&
    `
      & > button {
        background-color: ${buildColor("black", "60")};
      }
  `};
`;

export const RaceArrowNavigation = styled.div`
  display: flex;
  flex: 0 0 72px;
  flex-direction: row;
  align-items: stretch;
  margin-left: 8px;

  > a,
  span {
    &:first-child {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }

    &:last-child {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }
`;

const RaceNavigator = css`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: ${buildColor("black", "30")};

  &:active {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export const RaceArrowLink = styled(Link)`
  ${RaceNavigator};
`;

export const RaceArrowButton = styled.span`
  ${RaceNavigator};
`;

export default RaceHeaderContainer;
